import {Notification } from 'element-ui'
const mutations = {
    addData(state, data) {
        let testData = { }
        const a = state.tableData.find(item => item.id === data.id)
        if(a) {
            a.eventStatus = data.eventStatus
            a.eventStatusLabel = JSON.parse(data.eventStatusLabel)
            Notification.warning('你有一条数据状态发生了变化')
        } else {
            testData.id = data.id
            testData.eventStatusLabel = data.eventStatusLabel
            testData.eventStatus = data.eventStatus
            if(state.tableData.length > 3) {
                state.tableData.splice(0, 1)
            }
            state.tableData.unshift(testData)
            Notification.info('你有新的数据')
        }
    },
    // 初始化菜单
    initMenu(state, _this) {
        console.log(_this.$store.state.configMenuList);
        let ur =JSON.parse(localStorage.getItem('menuSettings'))?JSON.parse(localStorage.getItem('menuSettings')):[];
        state.configMenuList=ur;
        // state.configMenuList=JSON.parse(JSON.parse(_this.crypto.decrypt(localStorage.getItem('m')))//加密
    },
    changeData(state, data) {
        state.notCompare=data;
    },

    setAlarmId(state, data) {
        state.alarmId = data
    },

    setAlarmCount(state, data) {
        if (data.value || typeof data.value === 'number') {
            state[data.name] = data.value
        } else {
            if (data.type === 'add') {
                state[data.name] = state[data.name] + 1
            } else {
                state[data.name] = state[data.name] - 1
            }
        }

    },
	
	setIsHome(state,data){
		state.isHome=data
	},

	setIsBreakIM(state,data){
		state.isBreakIM=data
	},
	
	setIsIm(state,data){
		state.isIm=data;
	},
	
	// 清除登录信息
	clearLoginInfo(state,data){
		sessionStorage.removeItem('meetingId');
		sessionStorage.removeItem('groupId');
		localStorage.removeItem('eventUserId');
		localStorage.removeItem('token');
		localStorage.removeItem('ur');
		localStorage.removeItem('centerId');
		localStorage.removeItem('menuSettings');
	},
	//应急联动成员
	setGroupMember(state,data){
		state.notGroupMember=data;
	},
	//是否有新的报警
	setHasNewAlarm(state,data){
		state.hasNewAlarm=data;
	},
	//是否禁止消息发送
	setIsForbidden(state,data){
		state.isForbidden=data;
	},
	//已上报/已参与的groupId
	setVisionGroupId(state,data){
		state.visionGroupId=data
	},
	//当前会议
	setMeetingId(state,data){
		state.meetingId=data
	},
	//收到消息的会议Id
	setCurrentMeetingInfo(state,data){
		state.currentMeetingInfo=data
	},

	//消息铃铛内容更改
	setMsgBell(state,data){
		state.msgBell=data
	},

	// 顶部切换tab
	ADD_VISITED_VIEWS: (state, view) => {
		if (state.visitedViews.some(v => v.path === view.fullPath)) return
			state.visitedViews.push({
				name: view.name,
				path: view.fullPath,
				title: view.meta.title || 'home'
			})
		if (!view.meta.noCache) {
			state.cachedViews.push(view.name)
		}
	},
	DEL_VISITED_VIEWS: (state, view) => {
		for (const [i, v] of state.visitedViews.entries()) {
		if (v.path === view.path) {
			state.visitedViews.splice(i, 1)
			break
		}
		}
		for (const i of state.cachedViews) {
		if (i === view.name) {
			const index = state.cachedViews.indexOf(i)
			state.cachedViews.splice(index, 1)
			break
		}
		}
	},
	DEL_OTHERS_VIEWS: (state, view) => {
		for (const [i, v] of state.visitedViews.entries()) {
		if (v.path === view.path) {
			state.visitedViews = state.visitedViews.slice(i, i + 1)
			break
		}
		}
		for (const i of state.cachedViews) {
		if (i === view.name) {
			const index = state.cachedViews.indexOf(i)
			state.cachedViews = state.cachedViews.slice(index, i + 1)
			break
		}
		}
	},
	DEL_ALL_VIEWS: (state) => {
		state.visitedViews = []
		state.cachedViews = []
	},

	SET_HEADACTIVEINDEX (state, data) {
		state.headActiveIndex = data
	  },
	SET_LEFTACTIVEINDEX (state, data) {
	state.leftActiveIndex = data
	},




}

export default mutations
